const Container = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="max-w-[1600px] mx-auto w-full px-4 md:px-8">{children}</div>
  );
};

export default Container;
